import { render, staticRenderFns } from "./PocketmagsPlusPreview.vue?vue&type=template&id=f8958b72&scoped=true"
import script from "./PocketmagsPlusPreview.vue?vue&type=script&lang=js"
export * from "./PocketmagsPlusPreview.vue?vue&type=script&lang=js"
import style0 from "./PocketmagsPlusPreview.vue?vue&type=style&index=0&id=f8958b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8958b72",
  null
  
)

export default component.exports